import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import styles from './ProposalAid.module.scss';

export interface ProposalAidProps {
  aid?: LetrusApi.CompositionAid;
}

const ProposalAid: React.FC<ProposalAidProps> = ({aid}) => {
  return (
    <article className={styles.proposalAid}>
      <header>
        <h4>
          <strong>{aid?.title}</strong>
        </h4>
      </header>
      <p
        className={styles.content}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: aid?.content_html || '',
        }}
      />
      {aid?.content_image && (
        <figure>
          <img src={aid?.content_image} alt={aid?.alt_image} />{' '}
        </figure>
      )}
    </article>
  );
};

export default ProposalAid;
